import React from "react";

import { createContext, useState } from "react";

export const Context = createContext();

const AppContext = ({ children }) => {
  const [heading, setHeading] = useState("");
  const [action, setAction] = useState("");
  const [dashAction, setDashAction] = useState("complaint");
  const [agentPerf, setAgentPerf] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [agentCallData, setAgentCallData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(["TranscriptID", true]);
  const [data, setdata] = useState({});
  const [loading, setLoading] = useState(false);
  const [bulk, setBulk] = useState(false);
  return (
    <Context.Provider
      value={{
        heading,
        setHeading,
        action,
        setAction,
        dashAction,
        setDashAction,
        agentPerf,
        setAgentPerf,
        agentData,
        setAgentData,
        agentCallData,
        setAgentCallData,
        page,
        setPage,
        pageCount,
        setPageCount,
        sort,
        setSort,
        data,
        setdata,
        loading,
        setLoading
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
